import React from 'react';
import { FormattedHTMLMessage } from 'react-intl';
import styled from 'styled-components';
import Text from 'components/Text';
import { COLOR } from 'config';

import Card from './Card';
import { ImageGraphicCardContainer } from './ImageCard';
import Title from './Title';
import image from '../images/FB-Landing-Page-graphic3.png';

const StyledText = styled(Text)`
  line-height:2.35rem;
`;

const FreeDrink = () => {
  const icon = (<ImageGraphicCardContainer
    image={image}
    height="400"
    width="480"
    backgroundColor={COLOR.base}
    backgroundSize={'400px'}
    backgroundImageOnBottom
  />);

  return (
    <Card image={icon} flexDirection="row-reverse" noMargin mb={'3rem'}>
      <Title id="Free drinks and free crypto!" />
      <StyledText mb={'24px'}>
        <FormattedHTMLMessage id="What can be better than free Internet? The answer is free Internet along with free drinks and free crypto. Attend the Skycoin NYC meetup and receive 8 SKY as well as 20K Coin Hours directly to your Sky wallet. Rub shoulders with Skyfleet over drinks and explore the revolutionary Skycoin ecosystem on - at -" />
      </StyledText>
    </Card>
  );
};

export default FreeDrink;



// WEBPACK FOOTER //
// ./src/components/NYCMeetUpLanding/components/FreeDrink.js